import ZlrDiscuss from './discuss.vue'
import ZlrDiscussItem from './discuss-item.vue'
export default {
  ZlrDiscuss,
  ZlrDiscussItem
}
